<template>
  <div>
    <van-cell
      v-if="isNormalStyle"
      class="ry-form__dropdown">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
        <span
          v-if="current.showColor"
          :class="{'readonly-span' : current.value && current.value.length}"
          :style="{backgroundColor : current.value && current.value.length ? contentColor : ''}">
          {{contentText}}
        </span>
          <span v-else>
          {{contentText}}
        </span>
        </div>
        <div v-else-if="!isRead" @click="openSelect">
          <div class="ry-form__dropdown-input" style="border-radius: 4px;">
            <div class="select-item">
            <span
              class="content"
              :style="{backgroundColor: current.showColor ? actionsMap[currentValue].color || '#63B2EE' : '#fff', color: current.showColor ? '#fff' : '#000'}"
              v-if="currentValue">
            {{currentValue}}
          </span>
              <div v-else>
                {{current.fieldDes}}
              </div>
            </div>
            <van-icon
              v-if="currentValue && !isReadOnly"
              name="close"
              class="close-btn"
              @click.stop="clearData">
            </van-icon>
          </div>

        </div>

        <van-field
          v-if="!isRead && current.selectOption === '其他'"
          style="border: 1px solid #e6e6e6; padding: 5px;"
          v-model="current.value"
          @change="selectChange"
        ></van-field>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__dropdown-compact">

      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>

          <div class="ry-form__select-compact-container" style="flex-direction: column;">

            <div v-if="isRead">
          <span
            v-if="current.showColor"
            class="field-empty-tips"
            :class="{'readonly-span' : current.value && current.value.length}"
            :style="{backgroundColor : current.value && current.value.length ? contentColor : ''}">
             {{contentText}}
          </span>
              <span v-else class="field-empty-tips">
            {{contentText}}
          </span>
            </div>

            <div v-else class="ry-form__dropdown-input compact-container" @click="openSelect">
              <div class="select-item">
            <span
              class="content"
              :style="itemStyle"
              v-if="currentValue">
            {{currentValue}}
          </span>
                <div v-else class="placeholder">
                  {{current.fieldDes || isReadOnly ? '暂无内容' : '请选择'}}
                </div>
              </div>
              <van-icon
                v-if="currentValue && !isReadOnly"
                name="close"
                class="close-btn"
                @click.stop="clearData">
              </van-icon>
            </div>

            <van-field
              v-if="!isRead && current.selectOption === '其他'"
              style="border: 1px solid #e6e6e6; padding: 5px;"
              v-model="current.value"
              @change="selectChange"
            ></van-field>
          </div>
        </template>
      </van-field>
    </div>
    <template v-if="['otherForm', 'current_table'].includes(current.optionsType)">
      <SelectOptionsPopup
        ref="selectOptionsPopup"
        :fetchType="current.optionsType"
        :app-id="formSet.appId"
        :form-id="formSet.formId"
        :field-id="current.dataId"
        :query-field-id="current.relateFieldId"
        :filter-info="current.filterInfo"
        :table-field-id="current.tableFieldId"
        :advanced-filter="current.advancedFilter"
        :advanced-filter-info="current.advancedFilterInfo"
        :relate-data-source-type="current.relateDataSourceType"
        :relateFieldId="current.relateFieldId"
        :relateAppId="current.relateAppId"
        :relateFormId="current.relateFormId"
        :data="formSet.getValues()"
        :sortList="current.sortList"
        :currentTableId="current.currentTableId"
        :dataFieldId="current.dataFieldId"
        @selectComplete="selectValueComplete"
      ></SelectOptionsPopup>
    </template>
    <template v-if="current.optionsType === 'openApi'">
      <SelectOptionsPopup
        ref="selectOptionsPopup"
        fetchType="openApi"
        :app-id="formSet.appId"
        :form-id="formSet.formId"
        :field-id="current.dataId"
        :data="formSet.getValues()"
        :requestType="current.requestType"
        :requestUrl="current.requestUrl"
        :methodType="current.methodType"
        :headerList="current.headerList"
        :paramType="current.paramType"
        :paramList="current.paramList"
        :requestBody="current.requestBody"
        :resultList="current.resultList"
        :updateList="current.updateList"
        :sortList="current.sortList"
        @selectComplete="selectValueComplete"
      ></SelectOptionsPopup>
    </template>
    <template v-if="current.optionsType === 'relateData'">
    </template>
    <div @click.stop.prevent v-else>
      <van-action-sheet
        class="ry-form-action-sheet"
        v-model="show"
        :title="current.title"
        get-container="body"
        @select="onSelect"
        :close-on-click-action="true"
        :actions="actions">
      </van-action-sheet>
    </div>

    <RySelectPopup
      v-if="current.pluginConfig && current.pluginConfig.entryId"
      ref="rySelectPopup"
      :title="current.title"
      @selectComplete="selectComplete">
    </RySelectPopup>
  </div>
</template>

<script>
  import {current} from './mixin'
  import SelectOptionsPopup from "./component/SelectOptionsPopup";

  export default {
    mixins: [current],
    data() {
      return {
        show: false,
      }
    },
    components: {
      SelectOptionsPopup
    },
    created() {

      if (this.current.optionsType === 'relateData') {
        console.log('current---',this.current)
        // 如果是数据关联模式，初始化时，先获取一次options数据，后面如果相关条件的值发生变化时，再获取一次
        // this.visibleChange(true)
        document.addEventListener('FORM_FIELD_DATA_CHANGE', this.formFieldDataChange)
      }
    },
    computed: {
      currentValue() {
        if (this.current.value) {
          const option = this.current.options.filter(opt => opt.id === this.current.value)[0]
          if (this.optionsType === 'custom' && (!option || this.current.value === '其他')) {
            this.current.selectOption = '其他'
          }
          return option ? option.optionName : this.optionsType === 'custom' ? '其他' : this.current.value
        } else {
          if (this.current.selectOption === '其他') {
            return '其他'
          }
          return ''
        }
      },
      actions() {
        const val = this.current.value
        if (this.current.options.length) {
          return this.current.options.map(item => {
            const result = {name: item.id}
            if (val === item.id) {
              result.color = item.color
            } else {
              result.color = 'transparent'
            }
            return result
          })
        } else {
          return [{name: '暂无数据', disabled: true}]
        }

        // return this.current.options.map(item => {
        //   item.name = item.optionName
        //   if (!this.current.showColor) {
        //     item.color = "transparent"
        //   }
        //   return item
        // })
      },
      actionsMap() {
        const map = {}
        this.current.options.map(item => {
          map[item.id] = item
        })
        return map
      },
      contentText() {
        if (this.current.value && this.current.value.length) {
          const opt = this.current.options
            .filter(opt => opt.id === this.current.value)[0]
          return opt ? opt.optionName : this.current.value
        } else {
          return '暂无内容'
        }
      },
      contentColor() {
        if (this.current.value && this.current.value.length) {
          const opt = this.current.options
            .filter(opt => opt.id === this.current.value)[0]
          return opt ? opt.color : '#63B2EE'
        } else {
          return ''
        }
      },
      itemStyle() {
        if (this.current.showColor) {
          return {
            backgroundColor: this.actionsMap[this.current.value] ? this.actionsMap[this.current.value].color || '#63B2EE' : '#63B2EE',
            color: '#fff',
            padding: '0 12px',
            margin: '2px',
          }
        } else {
          return {
            backgroundColor: '#fff',
            color: '#000',
            padding: 0,
            margin: 0,
          }
        }
      }
    },
    methods: {
      onSelect(opt) {
        this.current.selectOption = opt.name
        if (this.current.selectOption === '其他') {
          this.current.value = ''
        } else {
          this.current.value = opt.name
        }
        console.log('this.current.value', this.current.value)
        this.selectChange()
        if (this.current.relateField === 1) {
          this.current.options.forEach(option => {
            if (option.id === opt.name) {
              // 找出当前选择的选项关联的目标字段，给目标字段的followShowList中加入自己的Id
              option.fieldsMap.forEach(fieldId => {
                let field = this.current.root.fields[fieldId]
                field.followShowList.push(`${this.current.dataId}_${option.id}`)
              })
            } else {
              // 找出没有选择的选项关联的目标字段，把目标字段的followShowList中自己的Id移除掉
              option.fieldsMap.forEach(fieldId => {
                let field = this.current.root.fields[fieldId]
                for (let i = field.followShowList.length - 1; i >= 0; i--) {
                  let id = field.followShowList[i]
                  if (id === `${this.current.dataId}_${option.id}`) {
                    field.followShowList.splice(i, 1)
                  }
                }
              })
            }
          })
        }
      },
      clearData() {
        this.onSelect({id: ''})
      },
      openSelect() {
        if (this.isReadOnly) return
        if (['otherForm', 'current_table'].includes(this.current.optionsType)) {
          if (this.$refs.selectOptionsPopup) {
            this.$refs.selectOptionsPopup.open(this.current.value)
          }
        } else if (this.current.optionsType === 'openApi') {
          if (this.$refs.selectOptionsPopup) {
            this.$refs.selectOptionsPopup.open(this.current.value)
          }
        } else if (this.current.optionsType === 'relateData') {
          if (this.$refs.selectOptionsPopup) {
            this.$refs.selectOptionsPopup.open(this.current.value)
          }
        } else {
          this.show = true
        }
      },
      selectChange() {
        this.controlChange()
        this.submitData()
      },
      selectValueComplete(val) {
        this.current.selectOption = val
        this.current.value = val
        this.selectChange()
      },


      formFieldDataChange(e) {

        if (e.detail) {
          const {
            fieldId,
            formId,
            rowIdx
          } = e.detail
          const conditionList = [...this.current.filterInfo.conditionList, ...this.current.advancedFilterInfo.conditionList]
          const isExist = conditionList.some(item => item.fixedValue === 'instance_value' && item.localFieldId === fieldId)
          console.log('formFieldDataChange---',this.current, isExist)
          if (isExist) {
            // this.visibleChange(true)
          }
        }
      }
    }
  }
</script>

<style lang="less">


</style>